<template>
  <v-card
    :class="singleHalfTime ? 'prognostic-card half-time ' : 'prognostic-card'"
    :style="!isBigometro() && isMultiple() ? 'height: 392px;' : ''"
    @click="openDialog()"
  >
    <div
      :class="
        checkHalfTime(matchBet.match.halfTime)
          ? isBigometro()
            ? 'half-time card-container'
            : 'half-time card-container not-bigometro'
          : 'card-container'
      "
      :style="
        index == 1 && matchBet.match.halfTime
          ? getCardSize() + 'position: relative; top: -1px;'
          : getCardSize()
      "
      v-for="(matchBet, index) in matchDetails.matchMarkets"
      :key="'match-' + index"
    >
      <v-row>
        <v-col>
          <!-- Header (Date and Logos) -->
          <v-row class="header-row">
            <!-- Date and Time -->
            <v-col cols="7">
              <v-list-item-subtitle class="match-date">
                <span class="green-label" v-if="matchBet.match.halfTime"
                  >HT</span
                >
                <span class="match-date"
                  >{{ matchBet.match.hour }} . {{ matchBet.match.date }}</span
                >
              </v-list-item-subtitle>
            </v-col>
            <!-- Team Logos -->
            <v-col cols="5">
              <div style="position: absolute; right: 24px">
                <v-list-item-avatar class="team-icon">
                  <v-img
                    :src="matchBet.match.awayTeam.image"
                    aspect-ratio="1"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-avatar class="team-icon">
                  <v-img
                    :src="matchBet.match.homeTeam.image"
                    aspect-ratio="1"
                  ></v-img>
                </v-list-item-avatar>
              </div>
            </v-col>
          </v-row>

          <div class="push-bottom">
            <!-- League -->
            <v-row v-if="!isBigometro()">
              <v-col cols="12" class="green-label">
                <a>{{ matchBet.match.competition.name }}</a>
              </v-col>
            </v-row>
            <!-- Markets -->
            <v-row v-if="isBigometro()">
              <v-col cols="12">
                <div
                  v-for="(item, index) in matchBet.bigoddsMarkets"
                  :key="'bet-' + index"
                  style="float: left"
                >
                  <v-chip
                    v-if="ellipsis == 0 || index < ellipsis"
                    class="market-chip"
                    label
                    small
                    :ref="'bet-' + index"
                    :class="
                      item.result == 'Certo'
                        ? 'result-success'
                        : item.result == 'Errado'
                        ? 'result-fail'
                        : ''
                    "
                    >{{
                      ellipsis > 0 && ellipsis == index
                        ? "..."
                        : item.market.name
                    }}</v-chip
                  >
                  <v-chip
                    v-else-if="ellipsis > 0 && ellipsis == index"
                    class="market-chip"
                    label
                    small
                    :ref="'bet-' + index"
                    >{{
                      ellipsis > 0 && ellipsis == index
                        ? "..."
                        : item.market.name
                    }}</v-chip
                  >
                </div>
              </v-col>
            </v-row>
            <!-- Teams -->
            <v-row class="team-row">
              <v-col cols="12">
                <div class="team-name">
                  {{ matchBet.match.homeTeam.name }} x
                  {{ matchBet.match.awayTeam.name }}
                </div>
              </v-col>
            </v-row>
            <!-- Labels -->
            <v-row class="chips-row">
              <v-col cols="12">
                <v-chip label x-small>{{ matchBet.match.country.name }}</v-chip>
                <v-chip label x-small>{{ matchBet.match.sport.name }}</v-chip>
                <v-chip label x-small>{{
                  matchBet.match.competition.name
                }}</v-chip>
              </v-col>
            </v-row>
            <!-- USERS -->
            <v-row
              :style="
                !isBigometro() && users.length > 0 ? '' : 'display: none;'
              "
            >
              <v-col cols="12">
                <UserAvatarList
                  :users="users"
                  :avatarSize="24"
                  :avatarOverlay="0.5"
                ></UserAvatarList>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-row v-if="isBigometro()">
      <v-col>
        <v-row
          class="bet-row"
          :style="isMultiple() ? 'padding-top: 16px;' : ''"
        >
          <v-col cols="3">
            <v-list-item style="padding: 0">
              <v-list-item-content style="padding: 0">
                <v-list-item-subtitle>Odd</v-list-item-subtitle>
                <v-list-item-title>{{ totalOdd }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="3">
            <v-list-item style="padding: 0">
              <v-list-item-content style="padding: 0">
                <v-list-item-subtitle>Bank</v-list-item-subtitle>
                <v-list-item-title>{{ totalBank }}%</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="6">
            <v-btn
              block
              large
              depressed
              :color="
                userBet()
                  ? '#26AB5E'
                  : userBet() == false
                  ? '#ffecbc'
                  : '#D8E0E6'
              "
              :class="
                userBet()
                  ? 'result-success'
                  : userBet() == false
                  ? 'result-warning'
                  : 'gray-btn'
              "
              style="border: none !important"
              @click.stop="showConfirmation()"
            >
              <v-icon small left>{{
                userBet() != null
                  ? "mdi-check-circle-outline"
                  : "mdi-circle-outline"
              }}</v-icon
              >{{ userBet() != null ? "Submetido" : "Submeter" }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- SUBMIT DIALOG -->
    <v-dialog v-model="submitDialog" max-width="372">
      <v-card>
        <v-row class="dialog-header">
          <!-- Team Logos -->
          <v-col
            style="
              flex: 0 0 90px;
              max-width: 90px;
              padding: 16px 0;
              margin-left: 30px;
            "
          >
            <div>
              <v-list-item-avatar class="team-icon" size="45">
                <v-img
                  :src="matchDetails.matchMarkets[0].match.awayTeam.image"
                  contain
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-avatar class="team-icon" size="45">
                <v-img
                  :src="matchDetails.matchMarkets[0].match.homeTeam.image"
                  aspect-ratio="1"
                ></v-img>
              </v-list-item-avatar>
            </div>
          </v-col>
          <!-- League and Teams -->
          <v-col class="match-details">
            <v-list-item style="padding: 0">
              <v-list-item-content style="padding: 0">
                <v-list-item-subtitle
                  class="green-label"
                  style="margin-bottom: 4px !important"
                  >{{
                    matchDetails.matchMarkets[0].match.competition.name
                  }}</v-list-item-subtitle
                >
                <v-list-item-title class="team-names"
                  >{{ matchDetails.matchMarkets[0].match.homeTeam.name }}
                  x
                  {{
                    matchDetails.matchMarkets[0].match.awayTeam.name
                  }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-card-title align="center">{{ submitTittle }}</v-card-title>
        <v-card-text style="padding: 0 48px 20px">{{ submitText }}</v-card-text>
        <v-list-item style="padding: 0 24px 12px 24px">
          <v-list-item-content style="padding-right: 8px">
            <v-btn
              block
              depressed
              color="secondary"
              height="48"
              @click="submitDialog = false"
              >Cancelar</v-btn
            >
          </v-list-item-content>
          <v-list-item-content style="padding-left: 8px">
            <v-btn
              block
              depressed
              color="primary"
              height="48"
              @click="submitBigometro(matchDetails)"
              >{{
                userBet()
                  ? "Remover"
                  : userBet() == false
                  ? "Remover"
                  : "Submeter"
              }}</v-btn
            >
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
    <!-- ERROR DIALOG -->
    <v-dialog v-model="noFundsDialog" max-width="372">
      <v-card>
        <div style="max-width: 100%; margin: 0 !important; padding-top: 32px">
          <v-btn text icon block disabled x-large>
            <v-icon style="color: #f83030 !important"
              >$icon-circle-error</v-icon
            >
          </v-btn>
        </div>
        <v-card-title align="center" style="word-break: normal !important">
          Para submeter prognósticos, tem de criar uma banca!
        </v-card-title>
        <v-list-item style="padding: 0 24px 12px 24px">
          <v-list-item-content>
            <v-btn
              block
              depressed
              dark
              color="#F83030"
              height="48"
              @click="noFundsDialog = false"
              >Continuar</v-btn
            >
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style scoped>
.prognostic-card .col {
  padding: 0 24px !important;
}
.card-container {
  padding: 16px 0 !important;
  position: relative;
}
.card-container:nth-child(2) {
  border-top: 1px solid #d8e0e6;
  border-bottom: 1px solid #d8e0e6;
}
.header-row .col:first-child {
  padding-right: 0 !important;
}
.header-row .col:nth-child(2) {
  padding-left: 0 !important;
}
.match-date {
  font-family: Gilroy-Bold;
  font-size: 11px;
  line-height: 14px;
  color: #bcc5cc !important;
}
.team-icon {
  margin: 0 !important;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
  float: right;
}
.team-icon >>> .v-image__image {
  background-size: 20px !important;
}
.team-icon:nth-child(2) {
  position: relative;
  left: 8px;
}
.push-bottom {
  position: absolute;
  bottom: 16px;
  width: 100%;
}
.green-label {
  font-size: 11px;
  line-height: 16px;
  padding-bottom: 0;
  font-family: Gilroy-Bold;
  color: #26ab5e;
  padding-right: 4px;
}
.team-row {
  display: flex;
  margin-bottom: 8px;
}
.team-name {
  font-family: Gilroy-Bold;
  font-size: 16px;
  line-height: 24px;
  color: #304351;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}
.chips-row {
  line-height: normal;
  max-width: 100%;
}
.bet-row .col {
  padding: initial !important;
  padding-bottom: 8px !important;
}
.bet-row .col:first-child {
  padding-left: 24px !important;
}
.bet-row .col:last-child {
  padding-right: 24px !important;
}
.bet-row >>> .v-list-item__subtitle {
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
  color: #bcc5cc !important;
}
.bet-row >>> .v-list-item__title {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #304351 !important;
}
.bet-row >>> .v-btn__content {
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  line-height: 16px;
}
.bet-row .gray-btn {
  color: #9aabb8 !important;
}
.bet-row .success-btn {
  color: #26ab5e !important;
}
.bet-row .warning-btn {
  color: #ffc121 !important;
}
.dialog-header {
  background: #f3f6f7;
  border-bottom: 1px solid #d8e0e6;
  max-width: 100%;
  margin: 0 0 16px 0 !important;
}
.dialog-header .team-icon {
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
}
.dialog-header .team-icon >>> .v-image__image {
  background-size: 24px !important;
}
.dialog-header .team-names {
  font-family: Gilroy-Bold;
  font-size: 14px;
  line-height: 16px;
  color: #304351;
}
</style>

<script>
import Vue from "vue";
import UserAvatarList from "@/components/UserAvatarList.vue";

import ApiService from "@/services/api.service";

export default Vue.extend({
  name: "PrognosticoCard",
  components: {
    UserAvatarList,
  },
  props: {
    matchDetails: {},
  },
  data: () => ({
    sum: 0,
    ellipsis: 0,
    singleHalfTime: false,
    submitDialog: false,
    noFundsDialog: false,
    submitTittle: "Submissão de prognóstico Bigómetro",
    submitText:
      "Tem a certeza que pretende submeter o prognóstico? Se posteriormente prentender alterar poderá sempre o fazer através do jogo.",
  }),
  mounted() {
    this.matchDetails.matchMarkets.forEach((market) => {
      // Apply ellipsis
      let sum = 0;
      let index = 0;
      for (const ref in this.$refs) {
        sum += this.$refs[ref][0].$el.offsetWidth + 12;
        if (sum > 210) {
          this.ellipsis = index;
          break;
        }
        index++;
      }
      this.sum = sum;
    });
  },
  methods: {
    isTiroCerteiro() {
      return this.$route.path.includes("tiro-certeiro");
    },
    isBigometro() {
      return this.$route.path.includes("bigometro");
    },
    isMultiple() {
      return this.matchDetails.matchMarkets.length > 1;
    },
    isPremium() {
      return this.$store.state.premium;
    },
    getBalance() {
      return this.$store.state.balance ? this.$store.state.balance : 0;
    },
    getCardSize() {
      if (this.isBigometro()) {
        if (this.isMultiple()) {
          return "height: 190px;";
        } else {
          return "height: 198px;";
        }
      } else {
        if (this.isMultiple()) {
          return "height: 196px;";
        } else {
          return "height: 198px;";
        }
      }
    },
    openDialog() {
      if (this.isPremium()) {
        this.$emit("open-dialog");
      }
    },
    sortArrayByLength(array) {
      return array.sort(function (a, b) {
        // ASC  -> a.length - b.length
        // DESC -> b.length - a.length
        return a.market.name.length - b.market.name.length;
      });
    },
    checkHalfTime(halfTime) {
      this.singleHalfTime = halfTime && !this.isMultiple();
      return halfTime && this.isMultiple();
    },
    showConfirmation() {
      if (this.userBet() != null) {
        this.submitTittle = "Remover prognóstico Bigómetro";
        this.submitText =
          "Tem a certeza que pretende remover o prognóstico? \nEsta operação irá afectar a sua banca.";
        this.submitDialog = true;
      } else {
        if (this.getBalance() > 0) {
          this.submitTittle = "Submissão de prognóstico Bigómetro";
          this.submitText =
            "Tem a certeza que pretende submeter o prognóstico? Se posteriormente prentender alterar poderá sempre o fazer através do jogo.";
          this.submitDialog = true;
        } else {
          this.noFundsDialog = true;
        }
      }
    },
    submitBigometro(item) {
      if (this.userBet() != null) {
        ApiService.removeBigometroBet(item.id).then(
          (response) => {
            this.$set(item, "bigometroBets", response.data.bigometroBets);
            this.submitDialog = false;
            this.$emit("update-bank");
          },
          (error) => {
            console.log(
              (error.response && error.response.data) ||
                error.message ||
                error.toString()
            );
          }
        );
      } else {
        ApiService.submitBigometro(item).then(
          (response) => {
            this.$set(item, "bigometroBets", response.data.bigometroBets);
            this.submitDialog = false;
            this.$emit("update-bank");
          },
          (error) => {
            console.log(
              (error.response && error.response.data) ||
                error.message ||
                error.toString()
            );
          }
        );
      }
    },
    userBet() {
      if (this.matchDetails.bigometroBets) {
        const uid = this.$store.state.user.uid;
        const bet = this.matchDetails.bigometroBets.filter(function (item) {
          return item.userId === uid;
        })[0];

        return bet == null ? null : bet.whileOpen;
      } else {
        return null;
      }
    },
  },
  computed: {
    users() {
      let users = [];
      this.matchDetails.matchMarkets[0].tiroCerteiroMarkets[0].outcomes.forEach(
        (outcome) => {
          users = users.concat(outcome.users);
        }
      );
      return users;
    },
    currentUser() {
      return this.$store.state.user;
    },
    totalBank() {
      let total = 0;
      this.matchDetails.matchMarkets.forEach((market) => {
        if (market.bigoddsMarkets) {
          market.bigoddsMarkets.forEach((item) => {
            total += item.bank;
          });
        }
      });
      return total;
    },
    totalOdd() {
      let total = 0;
      this.matchDetails.matchMarkets.forEach((market) => {
        if (market.bigoddsMarkets) {
          market.bigoddsMarkets.forEach((item) => {
            //total = total * item.odd;
            total == 0 ? (total = 1 * item.odd) : (total = total * item.odd);
          });
        }
      });
      return total.toFixed(2);
    },
  },
});
</script>
